import React, {createContext, useState} from "react";

export const CacheContext = createContext();
export const CacheContextProvider = ({ children }) => {

    setInterval(()=>{
        setCache((map) => {
            map.clear();
            return map;
          });
    },10*60*1500)

    const [cache,setCache] = useState(new Map());
    return <CacheContext.Provider value={[cache,setCache]} children={children} />;
};